module.exports = __webpack_public_path__ + "static/media/portfolio-1.ac78f581.jpg";